import React, { useEffect, useState } from 'react';

import { capitalize, Grid, Typography } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { CriteriaOption } from 'commons/components/SearchRelated';
import { useUpdateQueryParams } from 'commons/components/SearchRelated/SearchWithCriteria/hooks';
import { DeliveryNoteSearchCriteriaEnum } from 'commons/enums';
import { getDeliveryNoteListAction } from 'redux-stores/actions/dashboard.action';

import { ListFilterCard, ListPage } from '../commons/components';

import DeliveryNoteTable from './components/DeliveryNoteTable.component';

const DeliveryNoteListPage: React.FC = () => {
  const { queryParams, updateQueryParams } = useUpdateQueryParams();

  const searchCriteria: CriteriaOption[] = [
    {
      name: 'AWB Number',
      id: 'awb_number',
      isArray: true,
      parameterMapping: 'awb_numbers',
    },
    { name: 'Pharmacy ID', id: 'pharmacy_id' },
    { name: 'Priority', id: 'priority' },
  ];

  const statusArrayText: {
    key: DeliveryNoteSearchCriteriaEnum;
    text: string;
  }[] = Object.values(DeliveryNoteSearchCriteriaEnum).map((value) => ({
    key: value,
    text: capitalize(value.replace(/_/g, ' ')),
  }));

  const [statusFilter, setStatusFilter] =
    useState<DeliveryNoteSearchCriteriaEnum | null>(null);

  const updateDeliveryNoteListDebounce = useDebouncedCallback(
    (_searchParams, _location, _dispatch) => {
      _dispatch(
        getDeliveryNoteListAction({
          searchParams: _searchParams,
          locationId: _location,
        }),
      );
    },
    200,
    { maxWait: 1000 },
  );

  useEffect(() => {
    updateQueryParams({}, { clearOther: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStatusFilter = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    value: DeliveryNoteSearchCriteriaEnum,
  ): void => {
    setStatusFilter(value);
    updateQueryParams({ status: value }, { clearQueryParams: ['page'] });
  };

  return (
    <ListPage updateListSearchDebounce={updateDeliveryNoteListDebounce}>
      <ListFilterCard
        searchCriteria={searchCriteria}
        statusArrayText={statusArrayText}
        statusFilter={statusFilter}
        handleStatusFilter={handleStatusFilter}
      />
      {Object.keys(queryParams).includes('status') ? (
        <DeliveryNoteTable />
      ) : (
        <Grid container justifyContent="center">
          <Typography>Please select a status</Typography>
        </Grid>
      )}
    </ListPage>
  );
};

export default DeliveryNoteListPage;
